/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import AddConsignment from "components/addConsignments";
import {
  useAssignReplenishmentBags,
  useUpdateReplenishmentAfterCompletion
} from "utils/apis/replenishment.api";
import {
  useAssignKioskBags,
  useUpdateKioskAfterCompletion
} from "utils/apis/kiosk.api";
import {
  useAssignDeliveryBags,
  useUpdateDeliveryAfterCompletion
} from "utils/apis/deliveries.api";
import {
  useAssignB2BBags,
  useAssignB2BBulkBags,
  useUpdateB2BAfterCompletion
} from "utils/apis/b2b.api";
import EvhrPrint from "components/evhrPrint";
import {
  useAssignExchangeBags,
  useUpdateExchangeAfterCompletion
} from "utils/apis/exchange-service.api";
import {
  useAssignInterBranchBags,
  useUpdateInterBranchAfterCompletion
} from "utils/apis/inter-branch.api";
import { UserContext } from "utils/reducers/user";
import { useUpdateCollectionAfterCompletion } from "utils/apis/collections.api";
import { useUpdateClearanceAfterCompletion } from "utils/apis/clearance.api";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@repo/ui";
import { onSealFileUploadPayload } from "utils/helper";
import { LookUpContext } from "utils/reducers/lookup";
import { LucideFileDigit } from "lucide-react";
import DownloadTemplate from "./download-template";
import { ExcelExport } from "@progress/kendo-react-excel-export";

function ConsignmentsDetail({
  consignments,
  request,
  type,
  isResidual = false,
  isPackedCollection = false,
  isAddConsignment = true,
  isShowVhr = true,
  defaultBagType
}: {
  type:
    | "B2B"
    | "Delivery"
    | "Kiosk Service"
    | "Replenishment"
    | "Clearance"
    | "Collection"
    | "Exchange"
    | "InterBranch";
  consignments: any;
  defaultBagType: string;
  request?: any;
  isShowVhr?: boolean;
  isResidual?: boolean;
  isPackedCollection?: boolean;
  isAddConsignment?: boolean;
}) {
  const user = useContext(UserContext);
  const { allBagTypes, coinContainers, currencies } = useContext(LookUpContext);
  let excelExport: ExcelExport | null;

  const {
    vhrNo,
    containers,
    isTGDelivery: tgDelivery
  } = consignments || { vhrNo: null, containers: [], isTGDelivery: false };

  const [bagContainers, setBagContainers] = useState<any[]>([]);
  const [sealAssignType, setSealAssignType] = useState("");
  const [bagSealData, setBagSealData] = useState<any[]>([]);
  const [openSealFileUpload, setOpenSealFileUpload] = useState(false);
  const [isTGDelivery, setIsTGDelivery] = useState(tgDelivery);
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const {
    mutate: assignReplenishmentBags,
    isPending: isReplenishmentPending,
    isSuccess: isReplenishmentSuccess
  } = useAssignReplenishmentBags();
  const {
    mutate: assignKioskBags,
    isPending: isKioskPending,
    isSuccess: isKioskSuccess
  } = useAssignKioskBags();
  const {
    mutate: assignDeliveryBags,
    isPending: isDeliveryPending,
    isSuccess: isDeliverySuccess
  } = useAssignDeliveryBags();

  const {
    mutate: assignExchangeBags,
    isPending: isExchangePending,
    isSuccess: isExchangeSuccess
  } = useAssignExchangeBags();

  const {
    mutate: assignInterBranchBags,
    isPending: isInterBranchPending,
    isSuccess: isInterBranchSuccess
  } = useAssignInterBranchBags();

  const {
    mutate: assignB2BBags,
    isPending: isB2BPending,
    isSuccess: isB2BSuccess
  } = useAssignB2BBags();

  const {
    mutate: updateReplenishmentBags,
    isPending: replenishmentPending,
    isSuccess: replenishmentSuccess
  } = useUpdateReplenishmentAfterCompletion();

  const {
    mutate: updateClearanceBags,
    isPending: clearancePending,
    isSuccess: clearanceSuccess
  } = useUpdateClearanceAfterCompletion();

  const {
    mutate: updateKioskBags,
    isPending: kioskPending,
    isSuccess: kioskSuccess
  } = useUpdateKioskAfterCompletion();

  const {
    mutate: updateCollectionBags,
    isPending: collectionPending,
    isSuccess: collectionSuccess
  } = useUpdateCollectionAfterCompletion();

  const {
    mutate: updateDeliveryBags,
    isPending: deliveryPending,
    isSuccess: deliverySuccess
  } = useUpdateDeliveryAfterCompletion();

  const {
    mutate: updateB2bBags,
    isPending: b2bPending,
    isSuccess: b2bSuccess
  } = useUpdateB2BAfterCompletion();

  const {
    mutate: updateExchangeBags,
    isPending: exchangePending,
    isSuccess: exchangeSuccess
  } = useUpdateExchangeAfterCompletion();

  const {
    mutate: updateInterBranchBags,
    isPending: interBranchPending,
    isSuccess: interBranchSuccess
  } = useUpdateInterBranchAfterCompletion();

  const {
    mutate: assignBulkBags,
    isPending: assignBulkPending,
    data: assignBagData
  } = useAssignB2BBulkBags();

  const onConfirmAssignBags = (bags: any) => {
    if (type === "Replenishment") {
      assignReplenishmentBags({
        requestId: request?.requestId,
        consignments: bags
      });
    } else if (type === "Kiosk Service") {
      assignKioskBags({ requestId: request?.requestId, consignments: bags });
    } else if (type === "Delivery") {
      assignDeliveryBags({ requestId: request?.requestId, consignments: bags });
    } else if (type === "Exchange") {
      assignExchangeBags({ requestId: request?.requestId, consignments: bags });
    } else if (type === "B2B") {
      assignB2BBags({
        requestId: request?.requestId,
        consignments: bags,
        jobNo: request?.jobNo,
        isTGDelivery,
        consignmentsAssigned: request?.consignmentsAssigned
      });
    } else if (type === "InterBranch") {
      assignInterBranchBags({
        requestId: request?.requestId,
        consignments: bags
      });
    }
  };

  const onEditAssignedBags = (bags: any) => {
    const payload = {
      requestId: request?.requestId,
      jobNo: request?.jobNo,
      isTGDelivery,
      collectionVhr: {
        vhrNo,
        vhrEditType: consignments?.vhrEditType,
        corelationId: consignments?.corelationId,
        containers: bags
      }
    };
    if (type === "Replenishment") {
      updateReplenishmentBags(payload);
    }
    if (type === "Clearance") {
      updateClearanceBags(payload);
    } else if (type === "Kiosk Service") {
      updateKioskBags(payload);
    } else if (type === "Collection") {
      updateCollectionBags({
        requestId: request?.requestId,
        vhrs: [
          {
            vhrNo,
            vhrEditType: consignments?.vhrEditType,
            corelationId: consignments?.corelationId,
            containers: bags
          }
        ]
      });
    } else if (type === "Delivery") {
      updateDeliveryBags(payload);
    } else if (type === "Exchange") {
      updateExchangeBags(payload);
    } else if (type === "B2B") {
      updateB2bBags(payload);
    } else if (type === "InterBranch") {
      updateInterBranchBags(payload);
    }
  };

  const onAssignSealModal = (type: string) => {
    setOpenSealFileUpload(true);
    setSealAssignType(type);
  };

  const onConfirmBagSeals = () => {
    assignBulkBags(bagSealData);
  };

  const onSealFileUpload = async (event: any) => {
    const payload = await onSealFileUploadPayload(
      event,
      sealAssignType,
      allBagTypes,
      coinContainers,
      currencies,
      isTGDelivery
    );
    setBagSealData(
      payload?.map((item) => ({
        ...item,
        requestId: request?.requestId,
        jobNo: request?.jobNo
      })) || []
    );
  };

  function DetailComponent({ dataItem }: any) {
    const data = dataItem.packedCurrencies || [];
    if (data && data.length > 0) {
      return (
        <Grid data={data} style={{ width: "100%" }}>
          <GridColumn field="currency" title="Currency" />
          <GridColumn field="declaredValue" title="Declared Value" />
          <GridColumn field="exchangeRate" title="Exchange Rate" />
        </Grid>
      );
    }
    return <div style={{ height: "0px", width: "100%" }} />;
  }

  const expandChange = (event: { dataItem: any; value: boolean }) => {
    event.dataItem.expanded = event.value;
    setBagContainers([...bagContainers]);
  };

  useEffect(() => {
    if (
      type === "Exchange" &&
      request?.collectedConsignments?.containers?.length &&
      vhrNo &&
      !isAddConsignment
    ) {
      setBagContainers([
        ...containers,
        ...request?.collectedConsignments?.containers
      ]);
    } else if (containers?.length && vhrNo) {
      setBagContainers([...containers]);
    } else if (consignments?.containers?.length) {
      setBagContainers([...consignments?.containers]);
    } else if (!containers?.length) {
      setBagContainers([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containers]);

  useEffect(() => {
    if (assignBagData?.consignments?.length) {
      excelExport?.save(assignBagData?.consignments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagData]);

  return (
    <>
      {request && isShowVhr ? (
        <div className="flex justify-end gap-2 mb-3">
          {!vhrNo &&
          ["B2B"].includes(type) &&
          isAddConsignment &&
          request?.jobType === "Delivery" &&
          !["Completed", "Closed"].includes(request?.status) ? (
            <div className="flex items-center gap-1 mr-auto">
              <Checkbox
                checked={isTGDelivery}
                onCheckedChange={(checked) => {
                  setIsTGDelivery(Boolean(checked));
                }}
                id="tg-delivery-checkbox"
              />
              <label htmlFor="tg-delivery-checkbox" className="text-sm">
                TG Delivery
              </label>
            </div>
          ) : null}
          {!vhrNo &&
          [
            "B2B",
            "Delivery",
            "Kiosk Service",
            "Replenishment",
            "Exchange",
            "InterBranch"
          ].includes(type) &&
          isAddConsignment &&
          !["Completed", "Closed"].includes(request?.status) ? (
            <AddConsignment
              isTGDelivery={isTGDelivery}
              type={type}
              onConfirm={onConfirmAssignBags}
              isLoading={
                isReplenishmentPending ||
                isKioskPending ||
                isDeliveryPending ||
                isB2BPending ||
                isExchangePending ||
                isInterBranchPending
              }
              isSuccess={
                isReplenishmentSuccess ||
                isKioskSuccess ||
                isDeliverySuccess ||
                isB2BSuccess ||
                isExchangeSuccess ||
                isInterBranchSuccess
              }
              bags={bagContainers}
              defaultBagType={defaultBagType}
            />
          ) : null}
          {isTGDelivery &&
          type === "B2B" &&
          !["Completed", "Closed"].includes(request?.status) ? (
            <>
              <DownloadTemplate />
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="secondary" className="gap-2">
                    <LucideFileDigit /> Bulk Bags Assignment
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="w-[180px]">
                  <DropdownMenuItem
                    onClick={() => {
                      onAssignSealModal("Single Currency");
                    }}
                    className="cursor-pointer"
                  >
                    Single Currency
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onClick={() => {
                      onAssignSealModal("AED Coins");
                    }}
                    className="cursor-pointer"
                  >
                    AED Coins
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onClick={() => {
                      onAssignSealModal("Foreign Currency");
                    }}
                    className="cursor-pointer"
                  >
                    Foreign Currency
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          ) : null}
          {vhrNo ? (
            <div className="flex gap-2 my-3 ml-auto">
              {((["Out for Delivery"].includes(request?.status) &&
                request?.isBranchToATM) ||
                [
                  "Completed",
                  "Pending",
                  "Collected",
                  "Awaiting Delivery"
                ].includes(request?.status)) &&
              (user.Roles.includes("PA Supervisor") ||
                user.Roles.includes("PA Assistant")) ? (
                <AddConsignment
                  isTGDelivery={isTGDelivery}
                  isEdit
                  type={type}
                  onConfirm={onEditAssignedBags}
                  isLoading={
                    replenishmentPending ||
                    clearancePending ||
                    kioskPending ||
                    collectionPending ||
                    deliveryPending ||
                    b2bPending ||
                    exchangePending ||
                    interBranchPending
                  }
                  isSuccess={
                    replenishmentSuccess ||
                    clearanceSuccess ||
                    kioskSuccess ||
                    collectionSuccess ||
                    deliverySuccess ||
                    b2bSuccess ||
                    exchangeSuccess ||
                    interBranchSuccess
                  }
                  bags={bagContainers}
                  defaultBagType={defaultBagType}
                />
              ) : null}
              <EvhrPrint
                slipData={request}
                type={type}
                isResidual={isResidual}
                consignmentsDetail={consignments}
                isPackedCollection={isPackedCollection}
                closeModel={() => {}}
              />
            </div>
          ) : null}
        </div>
      ) : null}
      {vhrNo ? (
        <h3 className="mb-3 font-semibold text-2xl">{`VHR No: ${vhrNo}`}</h3>
      ) : null}
      <Grid
        data={bagContainers}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
        className="mb-3"
      >
        {isTGDelivery ? (
          <GridColumn
            field="sourceLocationBarcode"
            title="Source"
            cell={({ dataItem }) => (
              <td>
                {dataItem?.sourceLocationBarcode}-{dataItem?.sourceLocationName}
              </td>
            )}
          />
        ) : null}
        <GridColumn field="containerType" title="Bag Type" />
        <GridColumn field="containerId" title="Bag Id" />
        <GridColumn field="details" title="Details" />
        <GridColumn field="currency" title="Currency" />
        <GridColumn field="declaredValue" title="Value" format="{0:N2}" />
        <GridColumn field="localValue" title="Local Value" format="{0:N2}" />
        <GridColumn
          field="count"
          title="Count"
          cell={({ dataItem }) => (
            <td>
              {dataItem?.containerType === "Cheques"
                ? dataItem?.chequePieces
                : dataItem?.count}
            </td>
          )}
        />
        {[
          "B2B",
          "Delivery",
          "Kiosk Service",
          "Replenishment",
          "Exchange"
        ].includes(type) && (
          <GridColumn field="returnedCount" title="Returned Count" />
        )}
        <GridColumn field="sealNo" title="Seal No" />
        {[
          "B2B",
          "Delivery",
          "Kiosk Service",
          "Replenishment",
          "Exchange"
        ].includes(type) && <GridColumn field="status" title="Status" />}
        <GridColumn field="remarks" title="Remarks" />
      </Grid>
      <Dialog
        open={openSealFileUpload}
        onOpenChange={() => {
          setBagSealData([]);
          setOpenSealFileUpload(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{sealAssignType} Bags Assignment</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {bagSealData.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{bagSealData.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmBagSeals}
                    isLoading={assignBulkPending}
                    disabled={assignBulkPending}
                  >
                    Assign Seals
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      if (fileInputRef.current) fileInputRef.current.value = "";
                      setBagSealData([]);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onChange={onSealFileUpload}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <ExcelExport
        ref={(exporter) => {
          excelExport = exporter;
        }}
        fileName={`B2B_TG_Delivery_Bags_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "containerType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "declaredValue", title: "Value" },
          { field: "denominations", title: "Coins Denomination" },
          { field: "denomination", title: "Note Denomination" },
          { field: "count", title: "Count" },
          { field: "assigmentStatus", title: "Status" },
          { field: "locationId", title: "Location ID" }
        ]}
      />
    </>
  );
}

export default ConsignmentsDetail;
